import useMenuHighlighting from '../../hooks/useMenuHighlighting';
import Link from 'next/link';
import { RefObject } from 'react';
import { val } from '../../val.config';

export interface NavProps {
  chapters: { slug: string; header: string }[];
  chaptersRef: RefObject<(HTMLDivElement | null)[]>;
}

const Nav = ({ chapters, chaptersRef }: NavProps) => {
  const [currentChapterSlug] = useMenuHighlighting(chaptersRef);

  return (
    <div
      className="sticky top-1/4 left-0 self-start hidden tablet:flex flex-col gap-16 -ml-8"
      id="nav"
    >
      <h2 className="text-[24px] font-medium px-8">Innhold</h2>
      <div
        className={`flex flex-col gap-2 font-extralight text-[20px] leading-[140%]`}
      >
        {chapters.map((chapter, idx) => (
          <div
            className={`
              px-8 py-4
              ${
                currentChapterSlug === chapter.slug &&
                'bg-blue-700 text-blank-yellow'
              }`}
            key={idx}
          >
            <Link
              className="no-line-hover-line link_hover_line" // only add link underline on hover, not on focus
              href={'#' + val.raw(chapter.slug)}
            >
              {chapter.header}
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};
export default Nav;
